import './NaverBookMain.scss';
import * as S from '../scss/theme';
import React, { useState, useEffect } from "react";
import fnc from '../mymod/commFunction';
import Button from '@mui/material/Button';
import HongCombobox from '../comm/HongCombobox';
import HongInput from '../comm/HongInput';
import { useDispatch, useSelector } from 'react-redux';
import {  } from '../reduxToolkit/redux';
import Detail from '../page_naverBookApi/Detail';
import axios from "axios";

const NaverBookMain = () => {
    const svrUrl = process.env.REACT_APP_SERVER_URL;//svrUrl = 'http://localhost:8000';
    const dispatch = useDispatch();
   
    const [list, setList] = useState([]);
    const [isModal, setIsModal] = useState(false);

    const [isRefresh, setIsRefresh] = useState(false);

    const [options_kwamok, setOptions_kwamok] = useState([]);//과목
    const [options_chojoonggo, setOptions_chojoonggo] = useState([]);//과목

    const [sno, setSno] = useState(null);
    const [kwamok, setKwamok] = useState(null);
    const [kwamokCode, setKwamokCode] = useState(null);
    const [chojoonggo, setChojoonggo] = useState(null);
    const [chojoonggoCode, setChojoonggoCode] = useState(null);
    const [kwajung, setKwajung] = useState(null);
    const [isbn, setIsbn] = useState(null);
    const [bookCode, setBookCode] = useState(null);
    const [bookName, setBookName] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    
    useEffect(() => {
      fncSelect_list();
      fncSelect_kwamokList()
      fncSelect_chojoonggoList();
    }, [isRefresh]);

    
  function fncSelect_list() {  
    fnc.sendAxios('/kuesbNaverBookOrderRoutes/select/bookListAll', { }, (res) => {
      if (res && Array.isArray(res)) { 
        const listClass = getRecords(res);
        setList(listClass);
      } else {
        console.log(res,"/kuesbNaverBookOrderRoutes/select/bookListAll");
      }
    });
      
    function getRecords(res) {
      let records = [];
      res.forEach((item) => {
          const sno= item["sno"];
          const kwamokCode = item["kwamokCode"];
          const kwamok = item["kwamok"];
          const chojoonggo = item["chojoonggo"];
          const chojoonggoCode = item["chojoonggoCode"];
          const kwajung = item["kwajung"];
          const isbn = item["isbn"];
          const bookCode = item["bookCode"];
          const bookName = item["bookName"];
          let sDate = item["sDate"];
          sDate = fnc.formatDate2(sDate);
        
          records.push({ sno, kwamokCode, kwamok, chojoonggo, chojoonggoCode, kwajung, 
            isbn, bookCode, bookName, sDate });
        });  
        return records;
    }
  }

  

 //-----------------------------------------------과목
 function fncSelect_kwamokList() {
  const acaCode = fnc.getCookie('acaCode');
  const stCode = fnc.getCookie('stCode');
  
  fnc.sendAxios('/select/basic/kwamokList', { acaCode }, (res) => {
    if (res) { 
      const cmbListKwamok = getRecords_kwamok(res);
      setOptions_kwamok(cmbListKwamok);
    } else {
      console.log(res,"select/basic/kwamokList");
    }
  });

  function getRecords_kwamok(res) {
    let records = [];
    res.forEach(item => {
      const value = item["kwamokCode"];
      const label =item["kwamok"];
      if (value) {
        records.push({ value, label });
      }
    });
    return records;
  }
}
 //-----------------------------------------------초중고
  function fncSelect_chojoonggoList() {

      const resArray = getRecords_chojoonggo();
      setOptions_chojoonggo(resArray);

  }

 function getRecords_chojoonggo() {
  let records = [];
      records.push({ value:'1', label:'초' });
      records.push({ value:'2', label:'중' });
      records.push({ value:'3', label:'고' });
      return records;
}


  //----------------------------------------------------------------------------------------------

  function onRefresh() {

    fncSelect_list();

  }

  function onInsert() {

    if(!kwamok) {
      alert('과목을 선택하세요!');
      return null;
    }

    if(!chojoonggo) {
      alert('초중고를 선택하세요!');
      return null;
    }

    if(!kwajung) {
      alert('과정을 입력하세요!');
      return null;
    }

    if(!isbn) {
      alert('ISBN을 입력하세요!');
      return null;
    }

    // const rtn = window.confirm(`${isbn}을 등록하시겠습니까?`);
    // if(!rtn) return;

    const newBookCode = fnc.generateBookCode();

    fnc.sendAxios('/kuesbNaverBookOrderRoutes/insert/bookList', 
      { sno, kwamokCode, kwamok, chojoonggoCode, chojoonggo, kwajung, isbn, bookCode: newBookCode, bookName }, (res) => {
      if (res) {     
        if (res.success === 'exist') {
          alert(`${isbn}은 존재하는 ISBN입니다.`);
        } else {
          onRefresh(); 
        }

      } else {
        console.log(res,"/kuesbNaverBookOrderRoutes/insert/bookList");
      }
    });


  }

  
  function onUpdate() {
    if(!sno) {
      alert('대상을 선택하세요!');
      return;
    }
    if(!kwamok) {
      alert('과목을 선택하세요!');
      return null;
    }

    if(!chojoonggo) {
      alert('초중고를 선택하세요!');
      return null;
    }

    if(!kwajung) {
      alert('과정을 입력하세요!');
      return null;
    }

    if(!isbn) {
      alert('ISBN을 입력하세요!');
      return null;
    }

  
    const rtn = window.confirm(`대상을 수정하시겠습니까?`);
    if(!rtn) return;

    fnc.sendAxios('/kuesbNaverBookOrderRoutes/update/bookList', 
      { sno, kwamokCode, kwamok, chojoonggoCode, chojoonggo, kwajung, isbn, bookCode, bookName }, (res) => {
      if (res) {     
        onRefresh(); 
      } else {
        console.log(res,"kuesbNaverBookOrderRoutes/update/bookList");
      }
    });


  }

  function onDelete() {

      if(!sno) {
        alert('대상을 선택하세요!');
        return null;
      }

      const rtn = window.confirm(`${isbn}을 삭제하시겠습니까?`);
      if(!rtn) return;

      fnc.sendAxios('/kuesbNaverBookOrderRoutes/delete/bookList', { sno }, (res) => {
        if (res) { 
            setIsRefresh(!isRefresh);
        } else {
          console.log(res,"/kuesbNaverBookOrderRoutes/delete/bookList");
        }
      });
    
  }

  function onClickTr( item, index) {
    setSno(item.sno);
    setKwamokCode(item.kwamokCode);
    setKwamok(item.kwamok);
    setChojoonggo(item.chojoonggo);
    setChojoonggoCode(item.chojoonggoCode);
    setKwajung(item.kwajung);
    setIsbn(item.isbn);
    setBookCode(item.bookCode);
    setBookName(item.bookName);
    setSelectedItem(item);
  }

  const handleOption_kwamok = (value, label) => {
    setKwamokCode(value);
    setKwamok(label);
  };
  const handleOption_chojoonggo = (value, label) => {
    setChojoonggoCode(value);
    setChojoonggo(label);
  }
  const handleDetail = () => {

    searchBooksByIsbn(isbn);


  };

  const searchBooksByIsbn = async (isbn) => {//Isbn으로 검색
    if (!isbn || isNaN(Number(isbn))) {
      alert("유효한 ISBN을 입력하세요.");
      return;
    }

    try {
      const res = await axios.post(`${svrUrl}/search/book/isbn`, { isbn });
      // console.log(res.data,'res isbn');
      setSelectedItem(res.data[0]);
      setIsModal(true); 
    } catch (err) {
      const errorMessage = err.res?.data?.error || "검색 중 오류가 발생했습니다.";
      console.error(errorMessage);
      alert(errorMessage)
    }
  };

  
    //=========================================
    return (

      <div className="NaverBookMain">
        <div className="wrap-course-main">
          <section className="section-book-main">
            <table className="table-hong table-main">
              <thead>
                <tr>
                  <th>No</th>
                  <th>과목</th>  
                  <th>초중고</th>
                  <th>과정</th>
                  <th>교재명</th>
                  <th>ISBN</th>
                  {/* <th>BOOKCODE</th> */}
                  <th>작성일</th>
                </tr>
              </thead>

              <tbody>
                  {list && list.map((item, index) => (
  
                      <tr className={` ${item.sno === sno ? 'selected' : ''}`}
                      key={index} onClick={() => onClickTr(item, index)}>  
                        <td>{index+1}</td>
                        <td>{item.kwamok}</td>
                        <td>{item.chojoonggo}</td>
                        <td>{item.kwajung}</td>
                        <td>{item.bookName}</td>
                        <td>{item.isbn}</td>
                        {/* <td>{item.bookCode}</td> */}
                        <td>{item.sDate}</td>
                      </tr>
                  ))}
            
                </tbody>

            </table>
          </section>
        </div>

        <section className='section-input'>
        
        <div className='box-cmb'>
            <span className='lbl-cmb'>*과목</span>
              <HongCombobox 
                  label=''
                  value={kwamokCode || ''}
                  onChange={handleOption_kwamok}
                  options={options_kwamok}
                />
          </div>
          
          
          <div className='box-cmb'>
            <span className='lbl-cmb'>*초중고</span>
              <HongCombobox
                  label=''
                  value={chojoonggoCode || ''}
                  onChange={handleOption_chojoonggo}
                  options={options_chojoonggo}
                />
          </div>

          <div className='box-txt'>
            <span className='lbl-cmb'>*과정</span>
            <HongInput className='txt'
              value={kwajung}
              onChange={(e) => setKwajung(e.target.value)}>
            </HongInput>
          </div>

          <div className='box-txt'>
            <span className='lbl-cmb'>*교재명</span>
            <HongInput className='txt'
              value={bookName}
              onChange={(e) => setBookName(e.target.value)}>
            </HongInput>
          </div>

          <div className='box-txt'>
            <span className='lbl-cmb'>*ISBN</span>
            <HongInput className='txt'
              value={isbn}
              onChange={(e) => setIsbn(e.target.value)}>
            </HongInput>
          </div>

          {/* <div className='box-cmb'> //ISBN으로 대체
            <span className='lbl-cmb'>*BOOKCODE</span>
            <HongInput className='txt'
              value={bookCode}
              onChange={(e) => setBookCode(e.target.value)}>
            </HongInput>
          </div> */}

         
            
                    
        </section>

        <section className='section-btn'>
          <Button className='btn btnRefresh' onClick={onRefresh}>새로고침</Button> 
          <Button className='btn btnInsert' onClick={onInsert}>추가</Button> 
          <Button className='btn btnUpdate' onClick={onUpdate}>수정</Button> 
          <Button className='btn btnDelete' onClick={onDelete}>삭제</Button>  
          <Button className='btn btnDelete' onClick={handleDetail}>미리보기</Button>  
        </section> 

        {isModal && (
        <S.Modal>
          <Detail
            setIsModal={setIsModal}
            selectedItem={selectedItem} // 올바르게 상태 전달
          />
        </S.Modal>
        )}
       
      </div>
    );
}

export default NaverBookMain;